export default __webpack_public_path__ + "static/media/oberbayern_light.d036c43a.png";